exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".outer--3ICCb {\n\tpadding-bottom: 20px;\n\tposition: relative;\n}", ""]);

// Exports
exports.locals = {
	"outer": "outer--3ICCb"
};